export const SYSTEM_MODE = "SYSTEM_MODE"
export const LIGHT_MODE = "LIGHT_MODE"
export const DARK_MODE = "DARK_MODE"